import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import ContactForm from "@/components/KryvoCaptureForm";
import { MessageSquare, CalendarCheck, Rocket } from "lucide-react";

const steps = [
  { icon: MessageSquare, title: "You reach out", desc: "Tell us about your idea, project or product goals." },
  { icon: CalendarCheck, title: "We talk it through", desc: "A focused conversation to understand your needs and shape the right approach." },
  { icon: Rocket, title: "We get to work", desc: "A clear plan, then design and build — with you involved throughout." },
];

const Contact = () => (
  <>
    <Seo
      title="Contact Us | Kryvo Technologies"
      description="Have a project in mind? Let's discuss your ideas and turn them into a powerful digital product."
    />

    <section className="grid-bg bg-kryvo-mist pb-16 pt-[calc(72px+4rem)] sm:pb-20" data-testid="contact-hero">
      <div className="container-x max-w-3xl">
        <Reveal>
          <span className="eyebrow">
            <span className="h-px w-6 bg-kryvo-lime" aria-hidden="true" />
            Contact
          </span>
          <h1 className="mt-4 text-balance text-4xl font-semibold text-kryvo-ink sm:text-5xl">
            Let's Build Something Great Together.
          </h1>
          <p className="mt-5 text-base leading-relaxed text-kryvo-ink/65 sm:text-lg">
            Whether it's a website, a web application, an AI MVP, a mobile app — or you'd like to know
            more about Kryvo CRM or Kryvo Engage — send us a message and we'll take it from there.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="container-x grid gap-12 py-16 sm:py-20 lg:grid-cols-5" data-testid="contact-section">
      <div className="lg:col-span-3">
        <Reveal>
          <ContactForm />
        </Reveal>
      </div>
      <div className="lg:col-span-2">
        <Reveal delay={0.1}>
          <div className="rounded-2xl border border-kryvo-line bg-kryvo-mist p-8">
            <h2 className="text-2xl font-semibold text-kryvo-ink">What happens next?</h2>
            <ul className="mt-8 flex flex-col gap-7">
              {steps.map((s) => (
                <li key={s.title} className="flex gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-kryvo-line bg-white text-kryvo-green">
                    <s.icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-semibold text-kryvo-ink">{s.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-kryvo-sub">{s.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Contact;
